export const iconFontAwesomeAnimalsCow = (
	<i className="fa-solid fa-cow"></i>
);
